module.exports = __webpack_public_path__ + "static/media/2008_maleRate_femaleRate.51744fbf.png";